export default __webpack_public_path__ + "static/media/borrower-info.aaf99401.jpg";